/**
 * History
 *
 * Module Description
 *
 * @return {object}
 */

OT.createNS('OT.Search.History');

OT.Search.History = (function() {
    'use strict';

    var urlHistory = [],
        isSupported = !!(window.history && window.history.pushState);

    var setInitial = function(url, overrideHistory) {
        var params = OT.Search.Params.getAll();

        if((isSupported || overrideHistory) && window.performance !== undefined && window.performance.navigation.type !== 2) {
            window.history.replaceState(params, document.title, url || document.location.href);
        }

        urlHistory.push(_.clone(params));
    };

    var update = function(url, overrideHistory) {
        var params = OT.Search.Params.getAll();
        var newUrl = url ||
          document.location.href.replace(/\?.*/,  OT.Search.Requests.BuildUrl.queryString(params));


        if(isSupported || overrideHistory) {
            window.history.pushState(params, document.title, newUrl);
        }

        urlHistory.push(_.clone(params));
    };

    var back = function() {
        var len = urlHistory.length - 1;

        if(len > 0) {
            var params = get(len);
            OT.Search.Params.clear().set(params);
            urlHistory = urlHistory.splice(0, len);
        }
    };

    var get = function(index) {
        return urlHistory[index-1] || {};
    };

    var clear = function() {
        urlHistory = [urlHistory[0]];
    };

    var count = function() {
        return urlHistory.length;
    };

    return {
        update: update,
        setInitialState: setInitial,
        get: get,
        back: back,
        clear: clear,
        count: count,
        isSupported: isSupported
    };

})();